// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const METADATA = Object.freeze({
  author: `Sleepstation`,
  defaultImage: `/images/sleepstation.jpg`,
  homepageUrl: `https://sleepstation.org.uk`,
})

export default METADATA
